import React, { useState, useRef, useEffect } from "react";
import { Bell, User, LogIn, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { UNPROTECTED_ROUTES, PROTECTED_ROUTES } from "../../routes/routes";
import NotificationsDropdown from "./NotificationsDropdown";
import NotificationsDropdownMobile from "./NotificationsDropdownMobile";
import useLandingPageData from "../../utils/use-LandingPageData";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const HeaderMobileRightSection = () => {
  const [open, setOpen] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const dropdownRef = useRef();
  const dropdownNotificationRef = useRef();
  const landingPageData = useLandingPageData();
  const [dataOutput, setDataOutput] = useState(null);
  const [loading, setLoading] = useState(true);
  const user = useSelector((store) => store.user);
  const navigate = useNavigate();


  useEffect(() => {
    // Simulate API call
    const fetchData = async () => {
      setLoading(true);
      //   const res = await fetch("/api/landing-page");
      const data = await landingPageData;
      setDataOutput(data);
      setLoading(false);
    };

    fetchData();
  }, []);


  useEffect(() => {
    if (!open && !openNotification) return;

    const closeDropdowns = () => {
      setOpen(false);
      setOpenNotification(false);
    };

    window.addEventListener("scroll", closeDropdowns, { passive: true });
    window.addEventListener("touchmove", closeDropdowns, { passive: true });

    return () => {
      window.removeEventListener("scroll", closeDropdowns);
      window.removeEventListener("touchmove", closeDropdowns);
    };
  }, [open, openNotification]);


  const handleLogout = () => {
    setOpen(false);
    setOpenNotification(false);

    sessionStorage.clear();
    navigate(UNPROTECTED_ROUTES.login);
  };



  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when clicking outside = Notification
  useEffect(() => {
    function handleClickOutsideNotification(event) {
      if (dropdownNotificationRef.current && !dropdownNotificationRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutsideNotification);
    return () => document.removeEventListener("mousedown", handleClickOutsideNotification);
  }, []);
  console.log(PROTECTED_ROUTES, "PROTECTED_ROUTES");
  console.log(UNPROTECTED_ROUTES, "UNPROTECTED_ROUTES");
  console.log(landingPageData?.message, "landingPageData");
  console.log(user?.authenticated, "user?.authenticated")
  console.log("00000000000000000000000000000000000000")
  return (
    <div className="relative lg:hidden md:block block">
      {/* Icons */}
      <div className="flex flex-row items-center gap-4">
        {/* {
            dataOutput?.message === "success" ? <>
            <Bell className="cursor-pointer" onClick={() => setOpenNotification((prev) => !prev)} />
        <User
          className="cursor-pointer"
          onClick={() => setOpen((prev) => !prev)}
        /></>: <Link to={UNPROTECTED_ROUTES.login}><LogIn
        className="cursor-pointer"
        /></Link>
        } */}
        {user?.authenticated ||
          sessionStorage.getItem("authenticated") === "1" ? (
          <>
            <Bell className="cursor-pointer" onClick={() => { setOpen(false); setOpenNotification((prev) => !prev) }} />
            <User
              className="cursor-pointer"
              onClick={() => { setOpenNotification(false); setOpen((prev) => !prev) }}
            /></>
        ) : (
          <Link to={UNPROTECTED_ROUTES.login}><LogIn
            className="cursor-pointer"
          /></Link>
        )}
      </div>

      {/* Dropdown Profile */}
      {open && (
        <div
          ref={dropdownRef}
          className="absolute mt-2 right-0 bg-white shadow-lg rounded-lg w-40 z-50"
        >
          <ul className="py-2 text-sm text-gray-700">
            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
              <Link to={PROTECTED_ROUTES?.profile}>My Profile</Link>
            </li>
            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
              <Link to={UNPROTECTED_ROUTES?.feedback}>Feedback</Link>
            </li>
            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
              <Link to={PROTECTED_ROUTES?.support}>Support</Link></li>
            <li
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={handleLogout}
            >
              Logout
            </li>
          </ul>
        </div>
      )}

      {/* Dropdown Notification */}
      {openNotification && (
        <div
          ref={dropdownNotificationRef}
          className="absolute mt-2 right-0 bg-white shadow-lg rounded-lg w-40 z-50"
        >
          <NotificationsDropdownMobile openNotification={openNotification} />
        </div>
      )}
    </div>
  );
};

export default HeaderMobileRightSection;
